function currentTime() {
  let date = new Date(); 
  let dd = date.getDate();
  let mon = date.getMonth();
  let yy = date.getFullYear();
  let hh = date.getHours();
  let mm = date.getMinutes();
  let ss = date.getSeconds();
  let session = "AM";

    
  if(hh > 12){
      session = "PM";
   }
  if(hh > 13){
    hh = (hh - 12)
  }

   dd = (dd < 10) ? "0" + dd : dd;
   mon = (mon < 10) ? "0" + mon : mon;
   mm = (mm < 10) ? "0" + mm : mm;
   ss = (ss < 10) ? "0" + ss : ss;
    
   let time = hh + ":" + mm + ":" + ss + " " + session;

  document.getElementById("clock").innerText = time; 
  let t = setTimeout(function(){ currentTime() }, 1000); 

}

currentTime();
